import React from "react";
import RangerLayout from "layouts/RangerLayout/RangerLayout";

const Dashboard = () => {
  return (
    <RangerLayout title="All Farmers">
      <div>
        
      </div>
    </RangerLayout>
  );
};

export default Dashboard;
